(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-reviews')) {
    const STAR_PATH = 'm12 2.8 2.8 5.8 6.3.9-4.6 4.4 1.1 6.3L12 17.2l-5.6 3 1.1-6.3-4.6-4.4 6.3-.9L12 2.8Z';
    const STAR = `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="${STAR_PATH}" fill="currentColor"/></svg>`;
    const PERSON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="8" r="3.6" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M5 20c.8-3.6 3.6-5.6 7-5.6s6.2 2 7 5.6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
    const TICK = '<svg class="prv-review__tick" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const VERIFIED = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="2" y="2" width="20" height="20" rx="3" fill="#2bb673"/><path d="m7 12.5 3.2 3.2L17.5 8" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const ARROW_LEFT = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m15 6-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const ARROW_RIGHT = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 6 6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    const el = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    };

    const starsHtml = (value) => {
      let html = '';
      for (let i = 1; i <= 5; i += 1) {
        html += i <= Math.round(value) ? STAR : STAR.replace('<svg ', '<svg class="is-empty" ');
      }
      return html;
    };

    const normalizeApi = (value) => {
      let url = String(value || '').trim();
      if (!url) return '';
      // "rccoz.cloud", "https://rccoz.cloud/", "https:/rccoz.cloud" → https://rccoz.cloud
      url = `https://${url.replace(/^(https?:)?\/*/i, '')}`;
      try {
        return new URL(url).origin;
      } catch (error) {
        return '';
      }
    };

    /** 1 … 4 5 [6] 7 8 … 20 */
    const pageWindow = (current, total) => {
      const pages = new Set([1, total, current - 1, current, current + 1]);
      const list = [...pages].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b);
      const out = [];
      list.forEach((p, i) => {
        if (i && p - list[i - 1] > 1) out.push(null);
        out.push(p);
      });
      return out;
    };

    class ProductReviews extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';

        this.api = normalizeApi(this.dataset.api);
        this.shop = this.dataset.shop;
        this.productId = this.dataset.productId;
        this.perPage = parseInt(this.dataset.perPage, 10) || 5;
        this.page = 1;
        this.sort = 'newest';
        this.total = 0;
        this.step = 1;
        this.token = new URLSearchParams(window.location.search).get('review') || '';

        this.dialog = this.querySelector('[data-dialog]');
        this.form = this.querySelector('[data-form]');
        this.list = this.querySelector('[data-list]');
        this.pagination = this.querySelector('[data-pagination]');

        this.querySelector('[data-open-form]').addEventListener('click', () => this.openDialog());
        this.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.dialog.close()));
        // Arka plana tıklayınca kapat
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.querySelector('[data-back]').addEventListener('click', () => this.goTo(this.step - 1));
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
        this.form.addEventListener('change', (event) => {
          if (event.target.name !== 'rating') return;
          this.hideError('rating');
          if (this.step === 1) setTimeout(() => this.goTo(2), 220);
        });
        this.querySelector('[data-sort]').addEventListener('change', (event) => {
          this.sort = event.target.value;
          this.loadPage(1);
        });
        this.pagination.addEventListener('click', (event) => {
          const button = event.target.closest('[data-page]');
          if (!button || button.disabled) return;
          this.loadPage(parseInt(button.dataset.page, 10), true);
        });
        this.querySelector('[data-copy]').addEventListener('click', (event) => this.copyCoupon(event.currentTarget));

        this.goTo(1);
        if (!this.api || !this.productId) return;
        this.loadPage(1);
        if (this.token && !this.dataset.designMode) this.applyToken();
      }

      /* ---------- Liste ---------- */

      async loadPage(page, scroll) {
        const params = new URLSearchParams({
          shop: this.shop,
          productId: this.productId,
          limit: this.perPage,
          offset: (page - 1) * this.perPage,
          sort: this.sort
        });
        this.list.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(`${this.api}/api/product-reviews/public/reviews?${params}`, { cache: 'no-cache' });
          const data = await response.json();
          if (!data.ok) throw new Error(data.error || 'error');
          this.page = page;
          this.total = data.summary ? data.summary.count : 0;
          this.renderSummary(data.summary);
          this.list.textContent = '';
          data.reviews.forEach((review) => this.list.appendChild(this.renderReview(review)));
          this.querySelector('[data-empty]').hidden = this.total > 0;
          this.querySelector('[data-toolbar]').hidden = this.total < 2;
          this.renderPagination();
          if (scroll) this.querySelector('[data-toolbar]').scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (error) {
          if (!this.total) this.querySelector('[data-empty]').hidden = false;
        } finally {
          this.list.removeAttribute('aria-busy');
        }
      }

      renderSummary(summary) {
        if (!summary || !summary.count) return;
        const average = summary.average.toLocaleString('tr-TR', { minimumFractionDigits: 1, maximumFractionDigits: 2 });
        this.querySelector('[data-average-stars]').innerHTML = starsHtml(summary.average);
        this.querySelector('[data-average]').textContent = `5 üzerinden ${average}`;
        const count = this.querySelector('[data-count]');
        count.innerHTML = '';
        count.appendChild(document.createTextNode(`${summary.count} değerlendirmeye dayanmaktadır`));
        count.insertAdjacentHTML('beforeend', VERIFIED);
        count.hidden = false;

        for (let star = 1; star <= 5; star += 1) {
          const row = this.querySelector(`[data-bar="${star}"]`);
          const n = summary.distribution[star] || 0;
          row.querySelector('[data-bar-fill]').style.width = `${Math.round((n / summary.count) * 100)}%`;
          row.querySelector('[data-bar-count]').textContent = String(n);
        }
      }

      renderReview(review) {
        const item = el('article', 'prv-review');

        const top = el('div', 'prv-review__top');
        const stars = el('span', 'prv__stars');
        stars.innerHTML = starsHtml(review.rating);
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', `5 üzerinden ${review.rating} yıldız`);
        top.appendChild(stars);
        top.appendChild(el('span', 'prv-review__date', review.date));
        item.appendChild(top);

        const author = el('div', 'prv-review__author');
        const avatar = el('span', 'prv-review__avatar');
        avatar.innerHTML = PERSON + TICK;
        author.appendChild(avatar);
        author.appendChild(el('span', 'prv-review__name', review.name));
        author.appendChild(el('span', 'prv-review__badge', 'Doğrulanmış'));
        item.appendChild(author);

        item.appendChild(el('p', 'prv-review__body', review.body));
        return item;
      }

      renderPagination() {
        const pages = Math.ceil(this.total / this.perPage);
        this.pagination.textContent = '';
        this.pagination.hidden = pages <= 1;
        if (pages <= 1) return;

        const button = (page, html, label, current) => {
          const b = el('button', 'prv__page');
          b.type = 'button';
          b.dataset.page = String(page);
          b.innerHTML = html;
          b.setAttribute('aria-label', label);
          if (current) b.setAttribute('aria-current', 'page');
          if (page < 1 || page > pages) b.disabled = true;
          return b;
        };

        this.pagination.appendChild(button(this.page - 1, ARROW_LEFT, 'Önceki sayfa'));
        pageWindow(this.page, pages).forEach((p) => {
          if (p === null) this.pagination.appendChild(el('span', 'prv__page-gap', '…'));
          else this.pagination.appendChild(button(p, String(p), `Sayfa ${p}`, p === this.page));
        });
        this.pagination.appendChild(button(this.page + 1, ARROW_RIGHT, 'Sonraki sayfa'));
      }

      /* ---------- Modal / adımlar ---------- */

      openDialog() {
        if (!this.dialog.open) this.dialog.showModal();
      }

      goTo(step) {
        this.step = Math.max(1, Math.min(3, step));
        this.form.querySelectorAll('[data-steps]').forEach((node) => {
          node.hidden = !node.dataset.steps.split(' ').includes(String(this.step));
        });
        this.querySelector('[data-next]').textContent = this.step === 3 ? 'Yorumumu Gönder' : 'İleri';
        this.querySelectorAll('[data-progress] span').forEach((bar, i) => bar.classList.toggle('is-done', i < this.step));

        const focusTarget = { 2: 'textarea[name="body"]', 3: 'input[name="name"]' }[this.step];
        if (focusTarget && this.dialog.open) this.form.querySelector(focusTarget).focus();
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.step === 1) {
          if (this.validateRating()) this.goTo(2);
        } else if (this.step === 2) {
          if (this.validateRating() && this.validateBody()) this.goTo(3);
        } else {
          this.submit();
        }
      }

      validateRating() {
        if (this.form.querySelector('input[name="rating"]:checked')) return true;
        this.showError('rating', 'Lütfen bir puan seçin.');
        return false;
      }

      validateBody() {
        this.hideError('body');
        if (this.form.elements.body.value.trim().length >= 10) return true;
        this.showError('body', 'Yorumunuz en az 10 karakter olmalı.');
        return false;
      }

      // Davet mailinden gelen müşteri: sipariş zaten doğrulu, e-posta / sipariş no sorulmaz
      async applyToken() {
        try {
          const response = await fetch(`${this.api}/api/product-reviews/public/token-info`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ shop: this.shop, token: this.token, productId: this.productId })
          });
          const info = await response.json();
          if (!info.ok || (!info.productInOrder && !info.alreadyReviewed)) {
            this.token = '';
            return;
          }
          if (info.alreadyReviewed) {
            this.showDone('Teşekkür ederiz!', `${info.orderName} siparişinizdeki bu ürüne zaten yorum yaptınız.`);
          } else {
            const hello = info.firstName ? `Merhaba ${info.firstName}, ` : '';
            const verified = this.querySelector('[data-verified]');
            verified.textContent = `✓ ${hello}${info.orderName} siparişiniz doğrulandı.`;
            verified.hidden = false;
            this.querySelector('[data-order-fields]').hidden = true;
            if (info.displayName) this.form.elements.name.placeholder = info.displayName;
          }
          this.openDialog();
        } catch (error) {
          this.token = '';
        }
      }

      showError(field, message) {
        const node = this.querySelector(`[data-error="${field}"]`) || this.querySelector('[data-error="general"]');
        node.textContent = message;
        node.hidden = false;
        const input = this.form.elements[field];
        if (input && input.setAttribute) input.setAttribute('aria-invalid', 'true');
      }

      hideError(field) {
        const node = this.querySelector(`[data-error="${field}"]`);
        if (node) node.hidden = true;
        const input = this.form.elements[field];
        if (input && input.removeAttribute) input.removeAttribute('aria-invalid');
      }

      clearErrors() {
        this.querySelectorAll('[data-error]').forEach((node) => {
          node.hidden = true;
          node.textContent = '';
        });
        this.form.querySelectorAll('[aria-invalid]').forEach((node) => node.removeAttribute('aria-invalid'));
      }

      async submit() {
        this.clearErrors();
        const f = this.form.elements;
        const payload = {
          shop: this.shop,
          productId: this.productId,
          productHandle: this.dataset.productHandle,
          rating: (this.form.querySelector('input[name="rating"]:checked') || {}).value,
          body: f.body.value.trim(),
          name: f.name.value.trim(),
          token: this.token,
          email: this.token ? '' : f.email.value.trim(),
          orderName: this.token ? '' : f.orderName.value.trim()
        };

        let invalid = false;
        if (!this.token && !payload.email) { this.showError('email', 'E-posta adresinizi girin.'); invalid = true; }
        if (!this.token && !payload.orderName) { this.showError('orderName', 'Sipariş numaranızı girin.'); invalid = true; }
        if (invalid) return;

        const button = this.querySelector('[data-next]');
        button.disabled = true;
        button.textContent = 'Gönderiliyor…';
        try {
          const response = await fetch(`${this.api}/api/product-reviews/public/submit`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
          const data = await response.json();
          if (!data.ok) {
            if (data.field === 'rating' || data.field === 'body') this.goTo(2);
            this.showError(data.field || 'general', data.error || 'Bir hata oluştu, lütfen tekrar deneyin.');
            return;
          }
          if (data.approved) {
            this.showDone('Yorumunuz için teşekkürler!', 'Yorumunuz bu sayfada yayınlandı.', data);
            this.loadPage(1);
          } else {
            this.showDone('Yorumunuz için teşekkürler!', 'Yorumunuz kontrol edildikten sonra bu sayfada yayınlanacak.', data);
          }
        } catch (error) {
          this.showError('general', 'Bağlantı hatası. Lütfen tekrar deneyin.');
        } finally {
          button.disabled = false;
          if (this.step === 3) button.textContent = 'Yorumumu Gönder';
        }
      }

      showDone(title, text, data) {
        this.form.hidden = true;
        this.querySelector('[data-progress]').hidden = true;
        this.querySelector('[data-thanks]').hidden = false;
        this.querySelector('[data-thanks-title]').textContent = title;
        this.querySelector('[data-thanks-text]').textContent = text;
        this.querySelector('[data-open-form]').hidden = true;
        if (data && data.couponCode) {
          this.querySelector('[data-coupon]').hidden = false;
          this.querySelector('[data-coupon-code]').textContent = data.couponCode;
          this.querySelector('[data-coupon-mailed]').hidden = !data.mailed;
          this.querySelector('[data-coupon-own]').hidden = !data.customerOnly;
        }
      }

      async copyCoupon(button) {
        const code = this.querySelector('[data-coupon-code]').textContent;
        try {
          await navigator.clipboard.writeText(code);
          button.textContent = 'Kopyalandı ✓';
        } catch (error) {
          button.textContent = code;
        }
      }
    }

    customElements.define('product-reviews', ProductReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-buy-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Cart permalink ?discount= tek kod uyguluyor; birden fazla kod için Cart API kullanılıyor.
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-quick-buy-checkout]');
      if (!link) return;
      var section = link.closest('[data-quick-buy]');
      if (!section || !window.fetch) return;

      var variantId = section.dataset.qbVariantId;
      if (!variantId) return;
      event.preventDefault();
      if (link.dataset.qbBusy) return;
      link.dataset.qbBusy = '1';

      var updates = {};
      updates[variantId] = parseInt(section.dataset.qbQuantity, 10) || 1;
      if (section.dataset.qbGiftVariantId) updates[section.dataset.qbGiftVariantId] = 1;

      var body = { updates: updates };
      if (section.dataset.qbDiscount) body.discount = section.dataset.qbDiscount;

      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart update failed');
          return response.json();
        })
        .then(function (cart) {
          (cart.discount_codes || []).forEach(function (code) {
            if (!code.applicable) console.warn('[QuickBuy] İndirim kodu uygulanamadı:', code.code);
          });
          window.location.href = section.dataset.qbRedirect || '/checkout';
        })
        .catch(function () {
          window.location.href = link.href;
        });
    });

    // Geri tuşuyla sayfaya dönülürse butonu tekrar aktif et
    window.addEventListener('pageshow', function () {
      document.querySelectorAll('[data-quick-buy-checkout][data-qb-busy]').forEach(function (link) {
        delete link.dataset.qbBusy;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-ba8db227514723b9-pallet-calc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-ba8db227514723b9-calc')) {
    class ScPalletCalc extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.currency = this.dataset.currency || '';
        this.vatRate = parseFloat(this.dataset.vatRate) || 0;
        this.rows = Array.from(this.querySelectorAll('[data-row]'));

        this.addEventListener('click', (event) => {
          const step = event.target.closest('[data-step]');
          if (step && this.contains(step)) {
            const input = step.closest('[data-row]').querySelector('[data-qty]');
            this.setQty(input, this.read(input) + Number(step.dataset.step));
            return;
          }
          const cta = event.target.closest('[data-prefill]');
          if (cta && this.contains(cta)) this.prefill(cta);
        });

        this.addEventListener('input', (event) => {
          if (event.target.matches('[data-qty]')) this.update();
        });

        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-qty]')) this.setQty(event.target, this.read(event.target));
        });

        this.update();
      }

      read(input) {
        const value = parseInt(input.value, 10);
        return Number.isNaN(value) ? 0 : value;
      }

      clamp(input, value) {
        const min = parseInt(input.min, 10) || 0;
        const max = parseInt(input.max, 10) || 99;
        return Math.min(max, Math.max(min, value));
      }

      setQty(input, value) {
        input.value = this.clamp(input, value);
        this.update();
      }

      format(value) {
        const rounded = Math.round(value * 100) / 100;
        const digits = Number.isInteger(rounded) ? 0 : 2;
        const text = new Intl.NumberFormat('tr-TR', {
          minimumFractionDigits: digits,
          maximumFractionDigits: digits,
        }).format(rounded);
        return this.currency ? `${text} ${this.currency}` : text;
      }

      lines() {
        return this.rows.map((row) => {
          const input = row.querySelector('[data-qty]');
          const qty = this.clamp(input, this.read(input));
          const price = parseFloat(row.dataset.price) || 0;
          return { row, qty, title: row.dataset.title || '', total: qty * price };
        });
      }

      update() {
        let total = 0;
        this.lines().forEach(({ row, qty, total: lineTotal }) => {
          total += lineTotal;
          row.querySelector('[data-line]').textContent = this.format(lineTotal);
          row.classList.toggle('is-empty', qty === 0);
        });
        this.total = total;
        const totalEl = this.querySelector('[data-total]');
        const vatEl = this.querySelector('[data-vat-total]');
        if (totalEl) totalEl.textContent = this.format(total);
        if (vatEl) vatEl.textContent = this.format(total * (1 + this.vatRate / 100));
      }

      prefill(cta) {
        const href = cta.getAttribute('href') || '';
        if (!href.startsWith('#') || href.length < 2) return;
        let target = null;
        try {
          target = document.querySelector(href);
        } catch (error) {
          return;
        }
        if (!target) return;
        const textarea = target.querySelector('textarea[name="Açıklama"]') || target.querySelector('textarea');
        if (!textarea || textarea.value.trim() !== '') return;

        const word = this.dataset.palletWord || '';
        const delivery = this.querySelector('[data-delivery]');
        const text = [];
        if (delivery && delivery.value) text.push(`${this.dataset.deliveryLabel}: ${delivery.value}`);
        this.lines()
          .filter((line) => line.qty > 0)
          .forEach((line) => text.push(`- ${line.title}: ${line.qty} ${word} (${this.format(line.total)})`));
        text.push(`${this.dataset.totalLabel}: ${this.format(this.total)}`);
        text.push(`${this.dataset.vatLabel} (%${this.vatRate}): ${this.format(this.total * (1 + this.vatRate / 100))}`);

        textarea.value = text.join('\n');
        textarea.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    customElements.define('sc-ba8db227514723b9-calc', ScPalletCalc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trendyol-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('trendyol-reviews')) {
    const ICONS = {
      star: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m12 2.8 2.8 5.8 6.3.9-4.6 4.4 1.1 6.3L12 17.2l-5.6 3 1.1-6.3-4.6-4.4 6.3-.9L12 2.8Z" fill="currentColor"/></svg>',
      verified: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m12 2 2.4 1.8 3-.2.9 2.9 2.5 1.7-1 2.8 1 2.8-2.5 1.7-.9 2.9-3-.2L12 22l-2.4-1.8-3 .2-.9-2.9-2.5-1.7 1-2.8-1-2.8 2.5-1.7.9-2.9 3 .2L12 2Z" fill="currentColor"/><path d="m8.4 12.2 2.4 2.4 4.8-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      source: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 7h12l-1.2 12.2a1 1 0 0 1-1 .8H8.2a1 1 0 0 1-1-.8L6 7Z" fill="currentColor"/><path d="M9 9V6.5a3 3 0 0 1 6 0V9" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="m9.5 13.6 1.8 1.8 3.4-3.6" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      thumb: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3.5 10h3.5v10H3.5zM9 10l3.6-6.3c1.4 0 2.4 1.2 2.1 2.6L14 10h5.2a1.8 1.8 0 0 1 1.8 2.1l-1.2 6.4a1.8 1.8 0 0 1-1.8 1.5H9V10Z" fill="currentColor"/></svg>',
      prev: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m14.5 6-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      next: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9.5 6 6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    };

    const el = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    };

    const iconEl = (tag, className, icon) => {
      const node = el(tag, className);
      node.innerHTML = ICONS[icon];
      return node;
    };

    // "rccoz.cloud" veya tam uç nokta linki girilse de sadece https://alan-adi kısmını kullanır.
    const normalizeApi = (value) => {
      let url = String(value || '').trim();
      if (!url) return '';
      // "rccoz.cloud", "https://rccoz.cloud/", "https:/rccoz.cloud" → https://rccoz.cloud
      url = `https://${url.replace(/^(https?:)?\/*/i, '')}`;
      try {
        return new URL(url).origin;
      } catch (error) {
        return '';
      }
    };

    // contentId yerine Trendyol ürün linki yapıştırılırsa "-p-123" kısmından ID'yi alır.
    const normalizeContentId = (value) => {
      const text = String(value || '').trim();
      const match = text.match(/-p-(\d+)/) || text.match(/(\d{3,15})/);
      return match ? match[1] : '';
    };

    const initials = (name) => {
      const parts = String(name || '').replace(/\*/g, '').trim().split(/\s+/).filter(Boolean);
      if (!parts.length) return 'T';
      return parts.slice(0, 2).map((part) => part.charAt(0).toLocaleUpperCase('tr-TR')).join('');
    };

    // Trendyol CDN 820px yukseklikte gorsel veriyor; kartta kucuk gosterildigi icin genislige gore kucultulur.
    const resizeReviewImage = (url) => {
      const width = window.innerWidth < 750 ? 400 : 600;
      return String(url).replace(/\/mnresize\/[^/]+\/[^/]+\//, `/mnresize/${width}/-/`);
    };

    class TrendyolReviews extends HTMLElement {
      connectedCallback() {
        this.api = normalizeApi(this.dataset.api);
        this.contentId = normalizeContentId(this.dataset.contentId);
        this.limit = parseInt(this.dataset.limit, 10) || 4;
        this.mobileLimit = parseInt(this.dataset.mobileLimit, 10) || 3;
        this.designMode = this.dataset.designMode === 'true';
        this.track = this.querySelector('[data-track]');
        this.prevButton = this.querySelector('.tyr__nav--prev');
        this.nextButton = this.querySelector('.tyr__nav--next');
        this.status = this.querySelector('[data-status]');
        this.refreshButton = this.querySelector('[data-refresh]');

        this.prevButton.addEventListener('click', () => this.scrollCards(-1));
        this.nextButton.addEventListener('click', () => this.scrollCards(1));
        this.track.addEventListener('scroll', () => this.updateNav(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.updateNav());
        this.resizeObserver.observe(this.track);

        if (this.refreshButton) {
          this.refreshButton.addEventListener('click', () => this.load(true));
        }

        // Yorumlar sayfa acilisinda degil, bolume yaklasinca yuklenir (ilk gorselle bant genisligi yarismasin)
        if (this.designMode || !('IntersectionObserver' in window)) {
          this.load(false);
        } else {
          this.loadObserver = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.loadObserver.disconnect();
            this.load(false);
          }, { rootMargin: '600px 0px' });
          this.loadObserver.observe(this);
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.loadObserver) this.loadObserver.disconnect();
      }

      setStatus(message) {
        if (this.status) this.status.textContent = message;
      }

      async load(refresh) {
        if (!this.api || !this.contentId) {
          this.finish([]);
          return;
        }

        if (refresh) {
          this.refreshButton.disabled = true;
          this.setStatus('Trendyol yorumları çekiliyor, bu işlem biraz sürebilir...');
        }

        const params = new URLSearchParams({ limit: String(this.limit) });
        if (refresh) params.set('refresh', '1');
        const url = `${this.api}/api/review-widget/trendyol/${encodeURIComponent(this.contentId)}?${params}`;

        try {
          const response = await fetch(url, { cache: refresh ? 'no-store' : 'default' });
          const raw = await response.text();
          let data;
          try {
            data = JSON.parse(raw);
          } catch (parseError) {
            throw new Error(`Yorum servisi JSON yerine sayfa döndürdü (HTTP ${response.status}). "Yorum servisi adresi" ayarını kontrol edin: ${url}`);
          }
          if (!response.ok || !data.ok) throw new Error(data.error || `HTTP ${response.status}`);

          this.finish(data.reviews || []);

          if (this.designMode) {
            const synced = data.lastSyncedAt ? new Date(data.lastSyncedAt).toLocaleString('tr-TR') : '-';
            let message = `${(data.reviews || []).length} yorum gösteriliyor. Son güncelleme: ${synced}.`;
            if (refresh && data.cooldownSeconds) {
              message += ` Yeniden güncellemek için ${data.cooldownSeconds} sn bekleyin.`;
            } else if (refresh && data.refreshed) {
              message = `Güncellendi. ${message}`;
            }
            if (data.error) message += ` Uyarı: ${data.error}`;
            this.setStatus(message);
          }
        } catch (error) {
          if (!refresh) this.finish([]);
          this.setStatus(`Yorumlar alınamadı: ${error.message}`);
        } finally {
          if (this.refreshButton) this.refreshButton.disabled = false;
        }
      }

      finish(reviews) {
        this.track.replaceChildren();

        if (!reviews.length) {
          if (this.designMode) {
            this.track.append(el('p', 'tyr__empty', 'Gösterilecek 5 yıldızlı, görselli Trendyol yorumu bulunamadı.'));
          } else if (this.dataset.emptyText && this.dataset.emptyLink) {
            const fallback = el('a', 'tyr__fallback', this.dataset.emptyText);
            fallback.href = this.dataset.emptyLink;
            fallback.target = '_blank';
            fallback.rel = 'noopener noreferrer';
            this.track.append(fallback);
          } else {
            this.closest('.tyr').hidden = true;
          }
          this.updateNav();
          return;
        }

        reviews.slice(0, this.limit).forEach((review, index) => {
          this.track.append(this.renderCard(review, index));
        });

        requestAnimationFrame(() => this.updateNav());
      }

      renderCard(review, index) {
        const card = el('article', 'tyr-card');
        if (index >= this.mobileLimit) card.classList.add('tyr-card--mobile-hidden');

        card.append(this.renderMedia(review));

        const body = el('div', 'tyr-card__body');
        const head = el('div', 'tyr-card__head');
        head.append(el('span', 'tyr-card__avatar', initials(review.userName)));

        const who = el('div', 'tyr-card__who');
        const nameRow = el('div', 'tyr-card__name-row');
        nameRow.append(el('strong', 'tyr-card__name', review.userName || 'Trendyol Müşterisi'));
        if (review.date) nameRow.append(el('span', 'tyr-card__date', review.date));
        who.append(nameRow);

        const metaRow = el('div', 'tyr-card__meta');
        const stars = el('span', 'tyr-card__stars');
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', '5 üzerinden 5 yıldız');
        stars.innerHTML = ICONS.star.repeat(5);
        metaRow.append(stars);

        if (review.trusted && this.dataset.showVerified === 'true' && this.dataset.verifiedLabel) {
          const verified = iconEl('span', 'tyr-card__verified', 'verified');
          verified.append(document.createTextNode(this.dataset.verifiedLabel));
          metaRow.append(verified);
        }
        who.append(metaRow);
        head.append(who);
        body.append(head);

        body.append(el('p', 'tyr-card__comment', `“${review.comment}”`));

        const chips = el('div', 'tyr-card__chips');
        if (this.dataset.sourceLabel) {
          const source = iconEl('span', 'tyr-chip tyr-chip--source', 'source');
          source.append(document.createTextNode(this.dataset.sourceLabel));
          chips.append(source);
        }
        if (this.dataset.recommendLabel) {
          const recommend = iconEl('span', 'tyr-chip tyr-chip--recommend', 'thumb');
          recommend.append(document.createTextNode(this.dataset.recommendLabel));
          chips.append(recommend);
        }
        body.append(chips);

        card.append(body);
        return card;
      }

      renderMedia(review) {
        const media = el('div', 'tyr-card__media');
        const images = (review.images || []).filter((image) => image && image.url);
        const strip = el('div', 'tyr-media__track');

        images.forEach((image, index) => {
          const img = document.createElement('img');
          img.src = resizeReviewImage(image.url);
          img.alt = `${review.userName || 'Müşteri'} yorum görseli ${index + 1}`;
          img.loading = 'lazy';
          img.decoding = 'async';
          img.className = 'tyr-media__image';
          strip.append(img);
        });
        media.append(strip);

        if (images.length > 1) {
          const prev = iconEl('button', 'tyr-media__nav tyr-media__nav--prev', 'prev');
          const next = iconEl('button', 'tyr-media__nav tyr-media__nav--next', 'next');
          prev.type = 'button';
          next.type = 'button';
          prev.setAttribute('aria-label', 'Önceki görsel');
          next.setAttribute('aria-label', 'Sonraki görsel');

          const dots = el('div', 'tyr-media__dots');
          images.forEach(() => dots.append(el('span', 'tyr-media__dot')));

          const current = () => Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth));
          const go = (index) => {
            const target = (index + images.length) % images.length;
            strip.scrollTo({ left: target * strip.clientWidth, behavior: 'smooth' });
          };
          const sync = () => {
            const active = current();
            Array.from(dots.children).forEach((dot, index) => dot.classList.toggle('is-active', index === active));
          };

          prev.addEventListener('click', () => go(current() - 1));
          next.addEventListener('click', () => go(current() + 1));
          strip.addEventListener('scroll', sync, { passive: true });
          sync();

          media.append(prev, next, dots);
        }

        return media;
      }

      scrollCards(direction) {
        const card = this.track.querySelector('.tyr-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
      }

      updateNav() {
        const overflow = this.track.scrollWidth - this.track.clientWidth > 2;
        const atStart = this.track.scrollLeft <= 2;
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        this.prevButton.hidden = !overflow || atStart;
        this.nextButton.hidden = !overflow || atEnd;
      }
    }

    customElements.define('trendyol-reviews', TrendyolReviews);
  }

  } catch(e) { console.error(e); }
})();
})();
